// extracted by mini-css-extract-plugin
export default {"heading":"text_heading__T9bfk","text":"text_text__9+nSf"};